import presetHTML5 from '@bbob/preset-html5';
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++){
            arr2[i] = arr[i];
        }
        return arr2;
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
var _tags, _tags1, _tags2, _tags3;
var tagAttr = function(style) {
    return {
        attrs: {
            style: style
        }
    };
};
export default presetHTML5.extend(function(tags) {
    return _objectSpread({
    }, tags, {
        b: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _objectSpread({
            }, (_tags = tags).b.apply(_tags, _toConsumableArray(args)), tagAttr({
                fontWeight: 'bold'
            }));
        },
        i: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _objectSpread({
            }, (_tags1 = tags).i.apply(_tags1, _toConsumableArray(args)), tagAttr({
                fontStyle: 'italic'
            }));
        },
        u: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _objectSpread({
            }, (_tags2 = tags).u.apply(_tags2, _toConsumableArray(args)), tagAttr({
                textDecoration: 'underline'
            }));
        },
        s: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return _objectSpread({
            }, (_tags3 = tags).s.apply(_tags3, _toConsumableArray(args)), tagAttr({
                textDecoration: 'line-through'
            }));
        }
    });
});
